<div class="public-bg">
	<div class="public-content">
		<div class="public-app-logo">
			<img
				src="assets/images/logo.png"
				alt="App-Logo"
				class="is-logo-white" />
		</div>

		<div class="public-center-wrapper">
			<div class="public-wrapper">
				<h2 class="public-msg">{{ 'user-login-role-selection.message' | translate }}</h2>

				<div class="public-wrapper-container">
					@for (profile of profiles; track profile) {
						<div
							(click)="handleRoleSelect(profile)"
							class="public-wrapper-content simple-card is-action-card">
							<div class="d-none">
								<input
									type="radio"
									class="ms-2"
									id="{{ 'detailLink' + profile }}"
									name="{{ 'detailLink' + profile }}"
									(change)="handleRoleSelect(profile)" />
								<label for="{{ 'detailLink' + profile }}">
									<span>
										(Session {{ i }}) :: {{ username }} -
										<strong>{{ profile | translate: 'list-role' }}</strong>
									</span>
								</label>
							</div>
							<div class="public-wrapper-content-title">
								{{ getProfileTitleAndDescription(profile).title }}
							</div>
							<div class="public-wrapper-content-description">
								{{ getProfileTitleAndDescription(profile).description }}
							</div>
						</div>
					}

					<div class="public-footer">
						<div class="back-button">
							<eif-custom-button
								[text]="'button.back'"
								[color]="'neutral'"
								(click)="logout()">
							</eif-custom-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<eif-copyright></eif-copyright>
</div>
